import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

import { fadeIfAnimation } from '@app/animations';

@Component({
  selector: 'app-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.less'],
  animations: [fadeIfAnimation]
})
export class LoaderComponent {

  @Input() status$?: Observable<any>;

  constructor() {}

}
